import { c as _c } from "react/compiler-runtime";
import { getErrorMessage } from '@onefootprint/request';
import { useTranslation } from 'react-i18next';
type ErrorProps = {
  error: unknown;
  testID?: string;
};
const ERROR_MESSAGE_MAPPING = {
  'Not allowed: required permission is missing: CanDecrypt': 'decrypt-permission-error'
};
const ErrorComponent = t0 => {
  const $ = _c(13);
  const {
    error,
    testID
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let errorMessage;
  let t2;
  if ($[1] !== error) {
    errorMessage = getErrorMessage(error);
    t2 = Object.entries(ERROR_MESSAGE_MAPPING).find(t3 => {
      const [pattern] = t3;
      return errorMessage.includes(pattern);
    })?.[1];
    $[1] = error;
    $[2] = errorMessage;
    $[3] = t2;
  } else {
    errorMessage = $[2];
    t2 = $[3];
  }
  const translationKey = t2;
  let t3;
  if ($[4] !== errorMessage || $[5] !== t || $[6] !== translationKey) {
    t3 = translationKey === "decrypt-permission-error" ? t(_temp) : errorMessage;
    $[4] = errorMessage;
    $[5] = t;
    $[6] = translationKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const displayMessage = t3;
  let t4;
  if ($[8] !== displayMessage) {
    t4 = <p className="text-body-2 text-tertiary">{displayMessage}</p>;
    $[8] = displayMessage;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4 || $[11] !== testID) {
    t5 = <div data-testid={testID} className="flex flex-col gap-3 p-5">{t4}</div>;
    $[10] = t4;
    $[11] = testID;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default ErrorComponent;
function _temp($) {
  return $.decryptPermissionError;
}